// extracted by mini-css-extract-plugin
module.exports = {"inputSliderWrapper":"BudgetPerAdultFilter-module__inputSliderWrapper___cMS78"};